import React from 'react';
import { Stethoscope, Ambulance, Activity, ShieldCheck } from 'lucide-react';
import ScrollReveal from './ScrollReveal';

export default function Internships() {
    const internships = [
        {
            icon: <Activity size={32} />,
            title: "UTI e Estado Crítico",
            desc: "Aprenda na prática a lidar com pacientes de alta complexidade em Unidades de Terapia Intensiva."
        },
        {
            icon: <Ambulance size={32} />,
            title: "SAMU e Emergência",
            desc: "Treinamento real em situações de urgência, resgate e pronto-atendimento hospitalar."
        },
        {
            icon: <Stethoscope size={32} />,
            title: "Clínica e Cirúrgica",
            desc: "Assistência direta no pré e pós-operatório, acompanhando a evolução do paciente nos leitos."
        },
        {
            icon: <ShieldCheck size={32} />,
            title: "Saúde Coletiva e SPA",
            desc: "Vivência em unidades de saúde e Serviço de Pronto Atendimento focados na comunidade."
        }
    ];

    return (
        <section id="estagios" className="py-20 bg-conectiva-navy text-white relative overflow-hidden">
            {/* Elementos Decorativos de Fundo */}
            <div className="absolute top-1/2 left-0 -translate-y-1/2 -ml-32 w-96 h-96 bg-conectiva-lime opacity-5 rounded-full blur-[100px]"></div>

            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
                <ScrollReveal>
                    <div className="text-center mb-16">
                        <span className="inline-block px-3 py-1 bg-white/10 text-conectiva-lime font-bold rounded-full text-sm mb-4 border border-white/20">
                            ESTÁGIO SUPERVISIONADO: 400 HORAS
                        </span>
                        <h2 className="text-3xl md:text-5xl font-extrabold mb-6 leading-tight">
                            A experiência que o mercado <br /> <span className="text-transparent bg-clip-text bg-gradient-to-r from-conectiva-lime to-green-400">exige no seu currículo</span>
                        </h2>
                        <p className="text-gray-300 max-w-3xl mx-auto text-lg">
                            Na Connectiva, você faz os estágios supervisionados nos melhores hospitais, clínicas e unidades de emergência da região, somando 400 horas de muita mão na massa.
                        </p>
                    </div>
                </ScrollReveal>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                    {internships.map((item, index) => (
                        <ScrollReveal key={index} delay={index * 0.2}>
                            <div className="bg-white/5 border border-white/10 p-8 rounded-2xl hover:bg-white/10 hover:border-conectiva-lime/50 transition duration-300 group h-full">
                                <div className="mb-6 p-4 bg-conectiva-navy rounded-full inline-block text-conectiva-lime shadow-[0_0_15px_rgba(204,255,0,0.1)] group-hover:scale-110 group-hover:shadow-[0_0_25px_rgba(204,255,0,0.3)] transition-all">
                                    {item.icon}
                                </div>
                                <h3 className="text-xl font-bold text-white mb-3">{item.title}</h3>
                                <p className="text-gray-400 leading-relaxed text-sm">
                                    {item.desc}
                                </p>
                            </div>
                        </ScrollReveal>
                    ))}
                </div>
            </div>
        </section>
    );
}
